<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { SidebarGroup, SidebarGroupContent, SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from '@/components/ui/sidebar';
import { MessageSquare, BookOpen } from 'lucide-vue-next';

const { state } = useSidebar();

const livechatOpen = ref(false);
let unbind = null;
const unreadCount = ref(0);

onMounted(async () => {
    try {
        unbind = await window.Pylon('onChangeUnreadMessagesCount', updateUnreadCount);
    } catch (e) {
        console.error(e);
    }
});

onBeforeUnmount(() => {
    if (unbind) unbind();
});

function toggleLivechat() {
    livechatOpen.value ? window.Pylon('hide') : window.Pylon('show');
    livechatOpen.value = !livechatOpen.value;
}

function updateUnreadCount(data) {
    unreadCount.value = data.unread_count;
}
</script>

<template>
    <SidebarGroup class="mt-auto">
        <SidebarGroupContent>
            <SidebarMenu>
                <!-- Contact us -->
                <SidebarMenuItem>
                    <SidebarMenuButton size="sm" tooltip="Contact us" @click="toggleLivechat">
                        <div class="flex items-center justify-center p-1">
                            <MessageSquare class="mr-2" :class="state !== 'expanded' ? 'size-5' : 'size-4'" />
                            Contact Us
                            <span
                                v-if="unreadCount && state !== 'collapsed'"
                                class="ml-1 inline-flex items-center justify-center px-2 py-1 text-xs font-medium leading-none text-white bg-primary rounded-full">
                                {{ unreadCount }}
                            </span>
                        </div>
                    </SidebarMenuButton>
                </SidebarMenuItem>

                <!-- Docs -->
                <SidebarMenuItem>
                    <SidebarMenuButton size="sm" tooltip="Docs">
                        <a href="https://docs.streamkap.com" target="_blank" rel="noopener noreferrer" class="flex items-center justify-center p-1">
                            <BookOpen class="mr-2 size-4" />
                            Documentation
                        </a>
                    </SidebarMenuButton>
                </SidebarMenuItem>
            </SidebarMenu>
        </SidebarGroupContent>
    </SidebarGroup>
</template>
